// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  if (chunkId === 323) return "static/css/323.bd922fe7.css";
  // return url for filenames based on template
  return "" + chunkId + ".css"
}